<script>
import StrapCompatibility from '@phoenix/mixins/components/strap-search/StrapCompatibility';
import FindWatchReferenceWidgetMixin from '@maison/mixins/FindWatchReferenceWidgetMixin';
import { PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: { PhxIcon },

  mixins: [StrapCompatibility, FindWatchReferenceWidgetMixin],
};
</script>

<template>
  <form @submit.prevent="checkReference">
    <div class="strap-form">
      <div class="strap-form__text">
        {{ $t('StrapSearch.checkYourWatchCompatibilityHelp') }}
        <template v-if="findWatchReferenceModalId">
          <button
            class="link link--text text-white"
            data-modal-open="strap-size-guide"
            type="button"
            @click.prevent="openFindWatchReferenceModal"
          >
            {{ $t('StrapSearch.referenceNumber') }}
          </button>
          <phx-icon class="ico--small" icon="info" />
        </template>
        <template v-else>
          {{ $t('StrapSearch.referenceNumber') }}
        </template>
      </div>

      <input
        v-model="searchValue"
        type="text"
        class="input input--fluid strap-form__input"
        :placeholder="$t('StrapSearch.exampleRefNumber')"
        autocorrect="off"
      />
      <div class="sgphx">
        <button
          type="submit"
          :class="{ 'sgphx-btn sgphx-btn--primary sgphx-btn--positive': true, 'button--loading': isLoading }"
          :disabled="!canSubmitSearch"
        >
          <span v-if="isLoading" class="loader"></span>

          <span class="sgphx-btn__text">
            <span>{{ $t('StrapSearch.check') }}</span>
          </span>
        </button>
      </div>

      <template v-if="watchExists === false">
        <div class="strap-form__text text-status-danger">
          <phx-icon icon="cross-circle" class="ico--large" />
          <div class="scrim">{{ $t('StrapSearch.yourWatchHasNotBeenFound') }}</div>
        </div>

        <a class="button button--light button--text self-center" :href="contactLink">
          {{ $t('StrapSearch.contactUs') }}
        </a>
      </template>
      <template v-else-if="isCompatible === true">
        <div class="strap-form__text text-status-success">
          <phx-icon icon="check-circle" class="ico--large" />

          <div class="scrim">{{ $t('StrapSearch.yourWatchIsCompatible') }}</div>
        </div>
      </template>
      <template v-else-if="isCompatible === false && hasRelatedStraps === true">
        <div class="strap-form__text text-status-danger">
          <phx-icon icon="cross-circle" class="ico--large" />
          <div class="scrim">{{ $t('StrapSearch.yourWatchIsNotCompatible') }}</div>
        </div>

        <a class="button button--light button--text self-center" :href="searchResultLink">
          {{ $t('StrapSearch.seeAllCompatibleStrapsForYourReference') }}
        </a>
      </template>
      <template v-else-if="isCompatible !== null">
        <div class="strap-form__text text-status-danger">
          <phx-icon icon="cross-circle" class="ico--large" />
          <div class="scrim">{{ $t('StrapSearch.yourWatchIsNotCompatibleAndHasNoStraps') }}</div>
        </div>

        <a class="button button--light button--text self-center" :href="contactLink">
          {{ $t('StrapSearch.contactUs') }}
        </a>
      </template>
    </div>
  </form>
</template>
